/**
 * Trail segments ("walls") left behind by the bikes.
 * Ported from `Mur` (`Mur.h`) and the grid operations in `Grid.c`
 * (`ajouteMur`, `effaceMur`, `nettoieGrid`, `decrementeVieMur`).
 */

import type { PlayerColor } from "./types";

export interface Segment {
  x: number;
  y: number;
  w: number;
  h: number;
  color: PlayerColor;
  /** Remaining lifetime in ticks. Decreases by 1 per tick, removed below 1. */
  life: number;
  /** `life` at creation (== config.trailLife). Drives the "fresh trail" immunity. */
  maxLife: number;
}

export function makeSegment(
  x: number,
  y: number,
  w: number,
  h: number,
  color: PlayerColor,
  life: number,
): Segment {
  return { x, y, w, h, color, life, maxLife: life };
}

/** `decrementeVieMur`: ages every trail segment by one tick. */
export function ageSegments(segments: Segment[]): void {
  for (const s of segments) s.life -= 1;
}

/** `effaceMur`: drops expired segments (life < 1). Mutates in place. */
export function removeDeadSegments(segments: Segment[]): void {
  let write = 0;
  for (let read = 0; read < segments.length; read++) {
    const s = segments[read]!;
    if (s.life >= 1) segments[write++] = s;
  }
  segments.length = write;
}
